import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from 'components/icons/Icon';
import Button from 'components/inputs/Button';

export type ModalProps = {
  readonly onClose: () => unknown;
  readonly isInFront: boolean;
  readonly onSubmit?: () => unknown;
  readonly onCancel?: () => unknown;
  readonly submitText?: string;
  readonly cancelText?: string;
  readonly showCloseBtn?: boolean;
  readonly cancellable?: boolean;
  readonly closeOnSubmit?: boolean;
};

export default function Modal({
  children,
  onClose,
  isInFront,
  onSubmit,
  onCancel,
  submitText,
  cancelText,
  showCloseBtn = true,
  cancellable = true,
  closeOnSubmit = true,
}: React.PropsWithChildren<ModalProps>) {
  const { t } = useTranslation();

  function handleCancel() {
    onCancel?.();
    onClose();
  }

  function handleSubmit() {
    onSubmit?.();
    if (closeOnSubmit) {
      onClose();
    }
  }

  return (
    <div
      className="absolute inset-0 m-auto flex h-min w-[40vw] flex-col gap-4 rounded-lg bg-white px-8 py-6 max-xl:w-[85vw] max-md:h-screen max-md:w-screen max-md:justify-between max-md:rounded-none"
      style={{ zIndex: isInFront ? 10002 : 10001 }}
    >
      {showCloseBtn && (
        <div className="absolute top-2 right-2 cursor-pointer [&:hover_svg]:fill-black" onClick={onClose}>
          <Icon name="remove" />
        </div>
      )}
      {children}
      {(cancellable || onSubmit) && (
        <div className="flex justify-end gap-4">
          {onSubmit && (
            <Button aria-label={submitText ?? t('submit')} onClick={handleSubmit}>
              {submitText ?? t('submit')}
            </Button>
          )}
          {cancellable && (
            <Button btnType="secondary" aria-label={cancelText ?? t('cancel')} onClick={handleCancel}>
              {cancelText ?? t('cancel')}
            </Button>
          )}
        </div>
      )}
    </div>
  );
}
